import { AlertTriangle, GraduationCap } from "lucide-react";
import { RoleGroup } from "@/components/people/RoleGroup";

/** One unit's team, role by role, with its Coursera learners as one count. */
export const UnitTeam = ({ team, card, onTrained, showTrained }) => (
  <section id={`people-unit-${team.plant}`} data-testid={`people-unit-${team.plant}`} className="scroll-mt-24">
    <div className="flex flex-wrap items-end justify-between gap-3 border-b-2 border-foreground pb-2">
      <div>
        <h3 className="font-display text-xl font-black tracking-tight">
          {team.plant}
          <span className="ml-2 text-sm font-medium text-muted-foreground">{team.name}</span>
        </h3>
        <div className="mt-1 flex flex-wrap items-center gap-3 text-[11px] text-muted-foreground">
          <span data-testid={`unit-count-${team.plant}`}>{team.count} on the team</span>
          {team.can_edit && <span>you can update this team</span>}
          {!team.strength.SPOC ? (
            <span
              className="flex items-center gap-1 uppercase tracking-wider text-[hsl(var(--watch))]"
              data-testid={`unit-no-spoc-${team.plant}`}
            >
              <AlertTriangle className="h-3 w-3" /> No SPOC on record
            </span>
          ) : team.spoc_on_portal ? (
            <span data-testid={`unit-approver-${team.plant}`}>verified by {team.approvers.join(", ")}</span>
          ) : (
            <span
              className="flex items-center gap-1 uppercase tracking-wider text-[hsl(var(--watch))]"
              data-testid={`unit-no-approver-${team.plant}`}
            >
              <AlertTriangle className="h-3 w-3" /> SPOC not on the portal — no approver yet
            </span>
          )}
        </div>
      </div>
      {showTrained && (
        <button
          type="button"
          data-testid={`unit-trained-${team.plant}`}
          onClick={() => onTrained(team)}
          disabled={!team.trained}
          className="flex items-center gap-3 border border-border bg-card px-4 py-2 text-left transition-colors duration-200 hover:border-primary disabled:opacity-60"
        >
          <GraduationCap className="h-5 w-5 text-primary" />
          <span>
            <span className="label-caps block">Trained resources</span>
            <span className="font-display text-xl font-black" data-testid={`unit-trained-count-${team.plant}`}>
              {team.trained}
            </span>
            <span className="ml-1 text-[10px] text-muted-foreground">Coursera learners</span>
          </span>
        </button>
      )}
    </div>
    <div className="mt-3 space-y-4">
      {team.roles.map((g) => (
        <RoleGroup key={g.role} group={g} scope={team.plant} here={team.plant} card={card} />
      ))}
      {!team.roles.length && (
        <p className="text-sm text-muted-foreground" data-testid={`unit-empty-${team.plant}`}>
          No one on this team yet.
        </p>
      )}
    </div>
  </section>
);
